import { render } from "./AposImageCropper.vue?vue&type=template&id=52c05faa"
import script from "./AposImageCropper.vue?vue&type=script&lang=js"
export * from "./AposImageCropper.vue?vue&type=script&lang=js"

import "./AposImageCropper.vue?vue&type=style&index=0&id=52c05faa&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"image/ui/apos/components/AposImageCropper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52c05faa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52c05faa', __exports__)) {
    api.reload('52c05faa', __exports__)
  }
  
  module.hot.accept("./AposImageCropper.vue?vue&type=template&id=52c05faa", () => {
    api.rerender('52c05faa', render)
  })

}


export default __exports__